import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "../components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ClaimFreeWeek = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const memberToken = localStorage.getItem("memberToken");
  const memberData = JSON.parse(localStorage.getItem("memberData") || "{}");
  const memberId = memberData?.id;
  const firstName = memberData?.first_name || memberData?.name?.split(" ")[0] || "there";

  const handleClaim = async () => {
    if (!memberId) { navigate("/login"); return; }
    setLoading(true);
    try {
      await axios.post(
        `${API}/members/${memberId}/activate-free-week-pass`,
        {},
        { headers: { Authorization: `Bearer ${memberToken}` } }
      );
      if (window.fbq) window.fbq('track', 'Lead', { content_name: 'Free 1-Week Pass', content_category: 'Gym Offer' });
      if (window.gtag) window.gtag('event', 'generate_lead', { value: 0, currency: 'USD', lead_type: 'free_class' });
      toast.success("Your Free 1-Week Elite Pass is now ACTIVE!");
      navigate("/dashboard/classes");
    } catch (e) {
      const msg = e.response?.data?.detail;
      if (msg === "Free week pass already used") {
        toast.info("Your free week pass was already activated. Heading to booking...");
        navigate("/dashboard/classes");
      } else {
        toast.error(msg || "Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const expiry = new Date();
  expiry.setDate(expiry.getDate() + 7);
  const expiryStr = expiry.toLocaleDateString("en-US", { month: "long", day: "numeric", year: "numeric" });

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img
            src="/nbc_logo.jpg"
            alt="NBC" className="h-16 mx-auto mb-6"
          />
          <div className="inline-block bg-[#FFB612]/10 border border-[#FFB612]/30 px-4 py-1 mb-4">
            <p className="text-[#FFB612] text-xs font-bold uppercase tracking-widest">No Credit Card Required</p>
          </div>
          <h1 className="text-3xl font-black uppercase mb-3">Your Free<br />1-Week Elite Pass</h1>
          <p className="text-white/60">Hey {firstName}! Activate your pass — your 7 days start the moment you book your first class.</p>
        </div>

        <div className="bg-[#0A0A0A] border border-white/10 p-6 mb-6 space-y-3">
          <div className="flex justify-between text-sm">
            <span className="text-white/60">Pass Type</span>
            <span className="font-bold text-[#FFB612]">Elite Unlimited</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-white/60">Duration</span>
            <span className="font-bold">7 Days from First Booking</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-white/60">Classes Included</span>
            <span className="font-bold">Unlimited</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-white/60">Clock Starts</span>
            <span className="font-bold text-[#FFB612]">When You Book First Class</span>
          </div>
          <div className="border-t border-white/10 pt-3 flex justify-between">
            <span className="font-bold">Total</span>
            <span className="font-black text-xl text-[#FFB612]">$0.00</span>
          </div>
        </div>

        <Button
          onClick={handleClaim}
          disabled={loading}
          className="w-full bg-[#FFB612] text-black hover:bg-[#E5A00D] font-black uppercase text-lg py-6"
          data-testid="activate-free-week-btn"
        >
          {loading ? "Activating..." : "Activate My Free Week Pass →"}
        </Button>
        <p className="text-center text-white/30 text-xs mt-4">
          One-time offer. Pass expires 7 days after activation.
        </p>
      </div>
    </div>
  );
};
